export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.rentpilot.solutions/api";
export const APP_ENV = process.env.REACT_APP_ENV || "local";
export const APP_NAME = process.env.REACT_APP_NAME || "RentPilot";
export const GOOGLE_PLACES_API_KEY =
  process.env.REACT_APP_GOOGLE_PLACES_API_KEY || "";
